<form (ngSubmit)="approvalLevelsForm.valid && onSubmit()" #approvalLevelsForm="ngForm" [duplicateValueValidator]="['description-']">
	<div class="tabBody">
		<div class="table-wrapper">
			<mat-table class="table" [dataSource]="dataSource" matSort matSortActive="Ordinal" cdkDropList
				[cdkDropListDisabled]="dragDisabled || isReadOnly" (cdkDropListDropped)="drop($event)">
				<ng-container matColumnDef="move">
					<mat-header-cell *matHeaderCellDef>
						<button type="button" mat-icon-button color="primary" class="bs-button" title="Add new Level" (click)="addLevel()"
							[disabled]="!approvalLevelsForm.valid" *ngIf="!isReadOnly">
							<mat-icon>add_box</mat-icon>
						</button>
					</mat-header-cell>
					<mat-cell *matCellDef="let level">
						<mat-icon cdkDragHandle (mousedown)="dragDisabled = false" *ngIf="!isReadOnly" title="drag up or down">swap_vert</mat-icon>
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="Description">
					<mat-header-cell *matHeaderCellDef>
						<span class="heading-level">Level</span>
						<button type="button" mat-icon-button color="primary" class="bs-button" title="Sort list A-Z"
							(click)="sortTable('Description', true)" [disabled]="!approvalLevelsForm.valid" *ngIf="!isReadOnly">
							<i class="fa fa-sort-alpha-asc"></i>
						</button>
						<button type="button" mat-icon-button color="primary" class="bs-button" title="Sort list Z-A"
							(click)="sortTable('Description', false)" [disabled]="!approvalLevelsForm.valid" *ngIf="!isReadOnly">
							<i class="fa fa-sort-alpha-desc"></i>
						</button>
					</mat-header-cell>
					<mat-cell *matCellDef="let level">
						<input class="form-control" #desc="ngModel" [name]="'description-' + level.Id" [(ngModel)]="level.Description"
							maxlength="50" requiredNoWhitespace hasBegEndWhitespace #focusRef [readonly]="isReadOnly" />
						<mat-error *ngIf="desc.touched && desc.errors?.required">Level is required</mat-error>
						<mat-error *ngIf="desc.errors?.duplicateValue">Duplicate value</mat-error>
						<mat-error *ngIf="desc.errors?.hasBegEndWhitespace">Must not begin or end with blank space</mat-error>
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="addUsers">
					<mat-header-cell *matHeaderCellDef></mat-header-cell>
					<mat-cell *matCellDef="let level; index as index">
						<button mat-button color="primary" title="Add Users" type="button" (click)="openUsersDialog(level)"
							[disabled]="!approvalLevelsForm.valid">
							<span class="link">Users</span>
						</button>
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="Final">
					<mat-header-cell *matHeaderCellDef>
						<span title="Final Approval">Final</span>
					</mat-header-cell>
					<mat-cell *matCellDef="let level">
						<mat-icon *ngIf="!level.Final">block</mat-icon>
						<mat-icon *ngIf="level.Final">check</mat-icon>
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="remove">
					<mat-header-cell *matHeaderCellDef></mat-header-cell>
					<mat-cell *matCellDef="let level; index as index">
						<button *ngIf="canDelete(level)" type="button" mat-icon-button color="warn"
							class="bs-button" title="Delete Level" (click)="deleteLevel(index)">
							<mat-icon>delete</mat-icon>
						</button>
					</mat-cell>
				</ng-container>
				<mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
				<mat-row *matRowDef="let row; columns: columnsToDisplay" cdkDrag cdkDragLockAxis="y"></mat-row>
			</mat-table>
			<shared-no-data-available *ngIf="dataSource.data.length === 0 && isDataLoaded"></shared-no-data-available>
		</div>
	</div>
	<div class="save-wrapper" *ngIf="approvalLevelsForm.dirty">
		<div class="save-body">
			<div class="">
				<button mat-raised-button class="btn btn-cancelSave" type="button" (click)="onCancel()">
					CANCEL
				</button>
			</div>
			<div class="save-right">
				<button mat-raised-button color="primary" class="btn btn-save pull-right" type="submit" [disabled]="!approvalLevelsForm.valid">
					SAVE
				</button>
			</div>
		</div>
	</div>
</form>
